module.exports = __webpack_public_path__ + "static/media/tab2.1cf4b4f6.png";